module.exports = __webpack_public_path__ + "static/media/27.f7770cfe.png";